import { AfterViewChecked, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Router, RouterOutlet }                                              from '@angular/router';

import { Observable, Subscription } from 'rxjs';

import { routerAnimations } from '@shared/animations/animations';

import { Menu }     from '@models/navigation/menu';
import { AuthUser } from '@models/user/auth-user';

import { SiteSection } from '@models/layout/site-section';
import { LayoutTypes } from '@models/layout/layout-types.enum';

import { LayoutService } from '../layout.service';
import { UserService }   from '@services/user.service';


@Component({
  selector:    'red-layout-institutional',
  templateUrl: './layout-institutional.component.html',
  styleUrls:   [ './layout-institutional.component.scss' ],
  animations:  [ routerAnimations ]
})
export class LayoutInstitutionalComponent implements AfterViewChecked, OnInit, OnDestroy {

  private layoutSubscription: Subscription;

  public user$: Observable<AuthUser>;
  public toolbarType$: Observable<SiteSection>;
  public toolbarMenu$: Observable<Menu>;

  constructor(
    private router: Router,
    private changeDetectorRef: ChangeDetectorRef,
    private userService: UserService,
    private layoutService: LayoutService
  ) {
    this.user$        = this.userService.getActiveUser();
    this.toolbarType$ = this.layoutService.getSiteSection();
    this.toolbarMenu$ = this.layoutService.getToolbarMenu();
  }

  ngOnInit() {
    this.user$.subscribe((_user: AuthUser) => {
      this.layoutService.setActiveLayout(LayoutTypes.INSTITUTIONAL);
      this.layoutSubscription = this.layoutService.activeLayout$.subscribe();
    });
  }

  public prepareRoute(outlet: RouterOutlet) {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData[ 'animation' ] || null;
  }

  ngAfterViewChecked(): void {
    this.changeDetectorRef.detectChanges();
  }

  ngOnDestroy() {
    this.layoutSubscription.unsubscribe();
  }
}
